// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timer-wrapper {
  max-width: 500px;
}

.timer-bar {
  height: 4px;
  background-color: #e0e0e0;
  border-radius: 2px;
  overflow: hidden;
  margin-bottom: 4px;
}

.timer-progress {
  height: 100%;
  background-color: #666;
  transition: width 0.8s linear;
}

.timer-label {
  font-size: 10px;
  color: #757575;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/booking-timer/booking-timer.component.scss"],"names":[],"mappings":"AAAA;EAEI,gBAAA;AAAJ;;AAGE;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAAJ;;AAGE;EACE,YAAA;EACA,sBAAA;EACA,6BAAA;AAAJ;;AAGE;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AAAJ","sourcesContent":[".timer-wrapper {\n    // padding: 8px 16px 4px 8px;\n    max-width: 500px;\n  }\n  \n  .timer-bar {\n    height: 4px;\n    background-color: #e0e0e0;\n    border-radius: 2px;\n    overflow: hidden;\n    margin-bottom: 4px;\n  }\n  \n  .timer-progress {\n    height: 100%;\n    background-color: #666;\n    transition: width 0.8s linear;\n  }\n  \n  .timer-label {\n    font-size: 10px;\n    color: #757575;\n    text-align: center;\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
